import { config } from 'util/config';
import { httpClient } from "util/Api";
import React, { Fragment } from 'react';
import moment from 'moment';
import { message, Tooltip, Divider, Row, Col, Form, Button, Input, DatePicker, Select, InputNumber, Switch, AutoComplete, Tabs, Checkbox } from 'antd';
import { operationalFunction, getUieDataSource, getComponentDataSourceGroup } from 'components/UIBuilder/SectionFunction/Common';
import AdditionalForm from 'components/UIBuilder/AdditionalForm';
import * as createComponent from 'components/UIBuilder/CustomComponent/CreateComponent';
import * as globalFunction from 'util/GlobalFunction';

export default class DetailForm extends React.Component {
  constructor(props) {
    super();
    this.state = {
      currentDataKey: 0,
      initialValues: {},
      formData: {},
      componentDataSource: [],
      componentDefaultValue: [],
      uieCounter: 0,
      activeKey: 0,
      autoLoadComponentDataSource: true,
      checkedItems: {},
    }

    this.formRef = React.createRef();
    this.additionalFormRef = React.createRef();
    this.setFormValue = this.setFormValue.bind(this);
  };

  //页面启动
  componentDidMount() {
    setTimeout(() => {
      if (this.state.autoLoadComponentDataSource) {
        this.getComponentDataSource();
      }
    }, 20);
    this.getComponent();
  }

  //触发提交表单
  submitForm() {
    this.formRef.current?.submit();
  }

  //触发清空表单
  resetFields() {
    // this.setState({ formData: {} });
    this.formRef.current?.resetFields();
  }

  //同时修改状态表单和表单组件里, 对应字段的值
  setFormValue = (key, value) => {
    this.formRef.current?.setFieldsValue({ [key]: value });
  }

  //修改表单组件里的值, 修改状态表单对应的值
  onFormChange = (changedValues, allValues) => {
    this.props.sectionComponent.setState({ isFormModified: true });
  }

  //提交表单
  onFinish = async (values: any) => {
    operationalFunction({
      functionName: 'detailFormOnSubmit',
      sectionName: this.props.parentComponent.props.section.name,
      parameter: this.props.defaultFormData,
      formComponent: this,
      sectionComponent: this.props.sectionComponent,
      pageComponent: this.props.pageComponent
    })
  };

  //提交表单之前验证失败
  onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  //某些字段不能为0(- Select xxx -)，必须手选一个
  validateSelect = async (_, value) => {
    if (value === 0) {
      // 如果选择的是“0”，则返回错误
      return Promise.reject(new Error(''));
    }
    // 否则验证通过
    return Promise.resolve();
  };

  //访问后台获取表单配置
  getComponent() {
    //处理初值, 防止某些控件崩溃
    let initialValues = { ...this.state.initialValues };
    this.props.viewConfig.groupList.map((group, i) => {
      group.uieList.map((uie, i) => {
        switch (uie.component) {
          case 'RichTextEditor':
            initialValues[uie.source] = '';
            break;
        }
      })
    })
    this.setState({ initialValues });
  }

  //找到需要数据源的组件, 获取其数据源
  getComponentDataSource() {
    let parameter = [];
    if (this.props.companyId !== undefined && this.props.companyId !== null) {
      parameter.push({ key: 'companyId', value: this.props.companyId })
    }
    if (this.props.jobId !== undefined && this.props.jobId !== null) {
      parameter.push({ key: 'jobId', value: this.props.jobId });
    }
    if (this.props.moduleId !== undefined && this.props.moduleId !== null) {
      parameter.push({ key: 'moduleId', value: this.props.moduleId });
    }
    if (this.props.module !== undefined && this.props.module !== null) {
      parameter.push({ key: 'module', value: this.props.module });
    }
    if (this.props.state !== undefined && this.props.state !== null) {
      parameter.push({ key: 'state', value: this.props.state });
    }
    if (this.props.jobId !== undefined && this.props.jobId !== null) {
      parameter.push({ key: 'jobId', value: this.props.jobId })
    }
    if (this.props.subJobId !== undefined && this.props.subJobId !== null) {
      parameter.push({ key: 'subJobId', value: this.props.subJobId })
    }
    if (this.props.approvalId !== undefined && this.props.approvalId !== null) {
      parameter.push({ key: 'approvalId', value: this.props.approvalId })
    }
    // if (this.props.viewConfig.datasourceUrl === null) {
    //   this.props.viewConfig.groupList.map((group, i) => {
    //     group.uieList.map(async (uie, j) => {
    //       if (this.state.componentDataSource[uie.source] === undefined) {
    //         getUieDataSource({ parameter: parameter, sectionName: this.props.parentComponent.props.section.name, component: this, formComponent: this, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent, uie: uie });
    //       }
    //     })
    //   })
    //   setTimeout(() => {
    //     this.props.parentComponent.setState({ renderForm: true });
    //   }, config.setTimeoutMilliSecond);
    // } else if (this.props.viewConfig.autoDataSource) {
    //   getComponentDataSourceGroup({ parameter: parameter, sectionName: this.props.parentComponent.props.section.name, component: this, formComponent: this, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent });
    // }

    let parameterStr = '';
    parameter.forEach(item => {
      parameterStr += item.key + '=' + item.value + '&';
    })

    httpClient
      .get(this.props.component.datasourceUrl + '?' + parameterStr)
      .then(({ data }) => {
        this.props.sectionComponent.setState({ renderForm: true });
        let componentDataSource = this.props.sectionComponent.state.componentDataSource;
        if (data.result) {
          if (data.data.length > 0) {
            data.data.map((hash, i) => {
              let dataSource = hash.Value;
              let uie = null;
              this.props.component.groupList.filter(c => c.show).map((group, j) => {
                group.uieList.map((u, k) => {
                  if (u.source == hash.Key) {
                    uie = u;
                  }
                })
              })
              if (uie !== null) {
                if (uie.required) {
                  dataSource = dataSource.filter(item => item.Value !== 0);
                }
                componentDataSource[hash.Key] = dataSource;
                setTimeout(() => {
                  if (uie.component === 'Select' && (uie.type === null || uie.type.indexOf('multiple') < 0)) {
                    let formData = { ...this.state.formData };
                    if (this.props.pageComponent.formRef.current?.getFieldValue(uie.source) === null || this.props.pageComponent.formRef.current?.getFieldValue(uie.source) === undefined) {
                      if (uie.type === 'group') {
                        let dataSourceFilter = dataSource.filter(group => {
                          return group.SelectOptionList !== null && group.SelectOptionList.length > 0;
                        });
                        if (dataSourceFilter.length > 0) {
                          this.props.pageComponent.formRef.current?.setFieldValue(uie.source, dataSourceFilter[0].SelectOptionList[0].Value);
                        } else {
                          this.props.pageComponent.formRef.current?.setFieldValue(uie.source, dataSource[0]?.Value);
                        }
                      } else {
                        this.props.pageComponent.formRef.current?.setFieldValue(uie.source, dataSource[0]?.Value);
                      }
                    }
                    setTimeout(() => {
                      if (uie.onChange !== null) {
                        operationalFunction({ functionName: uie.onChange, sectionName: this.props.parentComponent.props.section.name, parameter: this.props.pageComponent.formRef.current?.getFieldValue(uie.source), data: dataSource[0], sectionComponent: this, pageComponent: this.props.pageComponent, uie: uie });
                      }
                    }, config.setTimeoutMilliSecond);
                  }
                }, config.setTimeoutMilliSecond)
              }
            });
            this.setState({ componentDataSource });
          }
        } else {
          globalFunction.handleResultError(data, this.props.pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, this.props.pageComponent);
      });
  }

  //创建表单UI - component
  createUI() {
    //查看tab分组信息
    let tabs = this.props.viewConfig.groupList.filter(c => c.tab !== null).map((group, i) => { return group.tab; }).filter((value, index, array) => array.indexOf(value) === index);
    if (tabs.length === 0) {
      //默认情况
      return this.props.viewConfig.groupList.filter(c => c.show).map((group, i) =>
        this.createGroup(group, i)
      );
    } else {
      //有分tab的情况, 生成tab标签页
      let tabItems = [];
      tabs.map((tab, i) => {
        let groups = this.props.viewConfig.groupList.filter(c => c.tab === tab);
        tabItems.push({
          label: <>{tab}</>,
          key: i,
          forceRender: true,
          children: groups.map((group, i) =>
            this.createGroup(group, i)
          )
        });
      })

      return <Tabs
        activeKey={this.state.activeKey}
        type="card"
        size="small"
        items={tabItems}
        onChange={(activeKey) => { this.setState({ activeKey }); }}
      />
    }
  }

  //记录condition group的checkbox状态，以展开对应的placeholder
  handleChange = (source, e) => {
    this.setState(prevState => ({
      checkedItems: {
        ...prevState.checkedItems,
        [source]: e.target.checked
      }
    }));
  };

  createGroup(group, i) {
    if (!globalFunction.isNullOrEmpty(group.conditionText)) {
      return <Row gutter={config.component.gutter} key={i} style={{ marginBottom: '16px' }}>
        {group.name !== null ? <Divider orientation="left" className={group.hideSeparatorLine ? 'hide-separator-line' : ''}>{group.name}{this.createGroupButton(group)}</Divider> : <></>}
        <div style={{ padding: '0px 15px' }}>
          <div style={{ marginBottom: '10px' }} dangerouslySetInnerHTML={{ __html: group.conditionText }}></div>
          <Col span={24}>
            <Form.Item name='ConditionCheck' valuePropName="checked" initialValue={false}>
              <Checkbox><span>{group.conditionCheckboxText}</span></Checkbox>
            </Form.Item>
          </Col>
        </div>
      </Row>
    } else if (!globalFunction.isNullOrEmpty(group.condition)) {
      if (this.state.formData.JobTypeName === group.condition) {
        return <Row gutter={config.component.gutter} key={i} style={{ marginBottom: '16px' }}>
          {group.name !== null ? <Divider orientation="left" className={group.hideSeparatorLine ? 'hide-separator-line' : ''}>{group.name}{this.createGroupButton(group)}</Divider> : <></>}
          <div style={{ padding: '0px 15px' }}>
            {
              group.uieList.map((uie, j) => {
                return <Col span={24} key={j}>
                  <Form.Item name={uie.source} valuePropName="checked" initialValue={false}>
                    <Checkbox onChange={(e) => this.handleChange(uie.source, e)}><span>{uie.title}</span></Checkbox>
                  </Form.Item>
                  {this.state.checkedItems[uie.source] && (
                    <div
                      style={{ padding: '0px 10px' }}
                      dangerouslySetInnerHTML={{ __html: uie.placeholder }}
                    />
                  )}
                </Col>
              })
            }
          </div>
        </Row >
      }
    } else {
      return <Row gutter={config.component.gutter} key={i} style={{ marginBottom: '16px' }}>
        {group.name !== null ? <Divider orientation="left" className={group.hideSeparatorLine ? 'hide-separator-line' : ''}>{group.name}{this.createGroupButton(group)}</Divider> : <></>}
        {this.createGroupUI(group)}
      </Row >
    }
  }

  createGroupButton(group) {
    return !globalFunction.isNullOrEmpty(group.buttonText) ?
      <Button
        type='link'
        onClick={() => operationalFunction({
          functionName: group.buttonOnClick,
          sectionName: this.props.parentComponent.props.section.name,
          parameter: this.props.defaultFormData,
          formComponent: this,
          sectionComponent: this.props.sectionComponent,
          pageComponent: this.props.pageComponent
        })}>{group.buttonText}</Button>
      : <></>
  }

  //创建表单UI - Group
  createGroupUI(group) {
    return group.uieList.map((uie, i) => {
      if (uie.show) {
        this.state.uieCounter++;
        let rules = [];
        rules.push({
          required: uie.required,
          message: ''
        });
        if (uie.pattern != null) {
          rules.push({
            required: false,
            pattern: new RegExp(uie.pattern, 'i'),
            message: ''
          });
        }
        if (uie.mandatorySelect) {
          rules.push({
            validator: this.validateSelect
          });
        }

        let valuePropName = 'value';
        switch (uie.component) {
          case 'Switch':
          case 'Checkbox':
            valuePropName = 'checked';
            break;
          case 'RichTextEditor':
            valuePropName = 'data';
            break;
        }
        switch (uie.component) {
          case 'RichTextEditor':
            return <Col xs={24} sm={uie.col} key={i}>
              <Form.Item
                label={uie.title}
                labelCol={{ span: uie.labelCol }}
                wrapperCol={{ span: uie.wrapperCol }}
                name={uie.source}
                rules={rules}
                valuePropName={valuePropName}
                getValueFromEvent={(event, editor) => {
                  const data = editor.getData();
                  return data;
                }}
              >
                {createComponent.createUIElement({ uie: uie, uieCounter: this.state.uieCounter, component: this, formComponent: this, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent, value: this.state.componentDefaultValue[uie.source] })}
              </Form.Item>
            </Col>
          case 'Select':
            switch (uie.type) {
              case 'Notify':
                return <Col xs={24} sm={uie.col} key={i}>
                  <Form.Item
                    style={{ width: '100%', display: 'inline-block' }}
                    label={uie.title}
                    labelCol={{ span: uie.labelCol }}
                    wrapperCol={{ span: uie.wrapperCol - 1 }}
                    name={uie.source}
                    rules={rules}
                    valuePropName={valuePropName}
                  >
                    {createComponent.createUIElement({ uie: uie, uieCounter: this.state.uieCounter, component: this, formComponent: this, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent, value: this.state.componentDefaultValue[uie.source] })}
                  </Form.Item>
                  <Tooltip mouseEnterDelay={config.component.Tooltip.mouseEnterDelay} title="Notify">
                    <Button
                      style={{ display: 'inline-block', position: 'absolute', marginLeft: '-15px', zIndex: '2', with: '25px' }}
                      icon={this.props.sectionComponent.state.Notify === true ? <img className="svg-img-btn" src={'assets/images/icon/email_solid.svg'} /> : <img className="svg-img-btn" src={'assets/images/icon/email_gray.svg'} />}
                      type="link"
                      onClick={() => operationalFunction({ uie: uie, functionName: uie.onClick, sectionName: this.props.sectionComponent.props.sectionName, parameter: null, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent })}
                    />
                  </Tooltip >
                </Col>
              default:
                return this.defaultComponent({ uie, i, rules, valuePropName });
            }
          case 'DatePicker':
            switch (uie.type) {
              case 'QuickDays':
                let days = [1, 7, 14, 30, 60];
                return <Col xs={24} sm={uie.col} key={i}>
                  <Form.Item
                    style={{ width: '65%', display: 'inline-block' }}
                    label={uie.title}
                    labelCol={{ span: uie.labelCol * 1.5 }}
                    wrapperCol={{ span: 24 - uie.labelCol * 1.5 }}
                    name={uie.source}
                    rules={rules}
                    valuePropName={valuePropName}
                  >
                    {createComponent.createUIElement({ uie: uie, uieCounter: this.state.uieCounter, component: this, formComponent: this, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent, value: this.state.componentDefaultValue[uie.source] })}
                  </Form.Item>
                  <span
                    style={{ width: '35%', display: 'inline-block', paddingLeft: '20px' }}
                  >
                    {
                      days.map((day, j) =>
                        <Button
                          key={j}
                          className='quick-days-button'
                          onClick={() => operationalFunction({ uie: uie, functionName: 'quickAddDays_' + uie.source, sectionName: this.props.sectionComponent.props.sectionName, parameter: day, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent })}
                        >{day}</Button>
                      )
                    }
                  </span>
                </Col>
              default:
                return this.defaultComponent({ uie, i, rules, valuePropName });
            }
          default:
            return this.defaultComponent({ uie, i, rules, valuePropName });
        }
      } else {
        return null
      }
    });
  }

  defaultComponent({ uie, i, rules, valuePropName } = {}) {
    return <Col xs={24} sm={uie.col} key={i}>
      <Form.Item
        label={uie.title}
        labelCol={{ span: uie.labelCol }}
        wrapperCol={{ span: uie.wrapperCol }}
        name={uie.source}
        rules={rules}
        valuePropName={valuePropName}
      >
        {createComponent.createUIElement({ uie: uie, uieCounter: this.state.uieCounter, component: this, formComponent: this, sectionComponent: this.props.sectionComponent, pageComponent: this.props.pageComponent, value: this.state.componentDefaultValue[uie.source] })}
      </Form.Item>
    </Col>
  }

  //----------------- render -----------------//
  render() {
    return (
      <div style={{ marginLeft: '15px', marginRight: '15px' }}>{this.createUI()}</div>
    );
  }
}
